<template>
  <NoticeCard
    :class="b()"
  >
    <el-row
      type="flex"
      align="middle"
    >
      <div
        v-if="data.state !== 1"
        :class="b('uploading')"
      >
        <SymbolIcon
          icon="icondengdai"
          :size="30"
        />
        <div>
          <div :class="b('tips-title')">
            {{ $t('notice.exporting') }}
          </div>
          <div :class="b('upload-tips-dec')">
            {{ $t('notice.exportOther') }}
          </div>
          <el-progress
            :show-text="false"
            :stroke-width="4"
            :percentage="progressNum"
            style="margin-bottom: 12px;"
          >
          </el-progress>
        </div>
      </div>

      <div
        v-else-if="data.state !== 0 && data.checkResult == true"
        :class="b('complete-have-fail')"
      >
        <div :class="b('tips-complete')">
          <SymbolIcon
            icon="iconchenggong1"
            :size="30"
          />
          <div :class="b('tips-complete-text')">
            <div :class="b('tips-title')">
              {{ $t('notice.exportSuccess') }}
            </div>
            <div :class="b('tips-num')">
              <template>
                <span
                  :class="b('tips-info')"
                  v-html="successRowText"
                />
              </template>
              <!--<span> {{ data.excelFileName }} </span>-->
            </div>
          </div>
        </div>
      </div>
    </el-row>
    <el-row
      type="flex"
      align="bottom"
    >
      <el-button
        v-if="data.state !== 1"
        :class="b('continue-import')"
        size="mini"
        @click="closeCurrent"
      >
        {{ $t('button.close') }}
      </el-button>
      <el-button
        v-if="data.state !== 0 && data.checkResult == true"
        :class="b('action-submit')"
        type="primary"
        size="mini"
        @click="downloadFile"
      >
        {{ $t('notice.downloadFile') }}
      </el-button>
    </el-row>
  </NoticeCard>
</template>
<script>
import theme from '@zk/theme/lib/variables.scss';
import NoticeCard from '@/components/notice/NoticeCard';
import { downloadOfUrl } from '@zk/framework-vue';
import { queryImportOrExportResult } from '@/api/message';
import { debounce } from 'lodash';

export default {
  name: 'ExportNoticeCard',
  components: {
    NoticeCard
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  bemNS: theme.bemNS,
  data() {
    return {
      startTimer: '',
      data: {},
      successRow: 0
    };
  },
  computed: {
    progressNum() {
      const { doneRow, totalRow } = this.data || {};
      return parseInt((doneRow / totalRow) * 100) > 100 ? 100 : parseInt((doneRow / totalRow) * 100) || 0;
    },
    state() {
      return this.data?.state;
    },
    successRowText() {
      const num = this.data?.errorRow ? this.successRow : this.totalRow;
      return this.$t('notice.exportSuccessNum', {
        successRow: this.$tc('common.count.num', num, { num: `<span class="${this.b('text-green')}">${ num }</span>` })
      });
    }
  },
  watch: {
    data: {
      handler(value) {
        this.$parent.showClose = value.state === 1;
        if (value && value.checkResult === true) {
          this.successRow = parseInt(value.totalRow - value.errorRow) ;
          this.totalRow = value.totalRow;
        }
      },
      immediate: true
    }
  },
  created() {
    this.load();
    this.time();
  },
  destroyed() {
    clearTimeout(this.set);
  },
  methods: {
    time() {
      this.set = setTimeout(async() => {
        if (this.data.state !== 1) {
          await this.load();
          this.time();
        }
      }, 1000);
    },
    load: debounce(async function() {
      const res = await queryImportOrExportResult({ 'uuid': this.id });
      if (res) {
        this.data = res;
        if (!res.checkResult && res.state !== 0) {
          this.$message.error(this.$t('notice.exportFail'));
          return;
        }
      }
    }, 500),
    downloadFile() {
      const url = this.data.checkResult ? this.data.fileName : '';
      const name = this.data.excelFileName || url.split('/').reverse()[0] || `${Date.now()}.xlsx`;
      url ? downloadOfUrl(url, name) : '';
      this.$parent.close();
    },
    closeCurrent() {
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss">
@include b(export-notice-card) {
  // padding: 0 0 0 7px;
  .zk-export-notice-card__text-green {
    color: #0EB83A;
    margin: 0 !important;
  }
  svg {
    margin-right:  var(--m-small);
    flex-shrink: 0;
  }
  .zk-export-notice-card__uploading {
    display: flex;
    .zk-export-notice-card__upload-tips-dec {
      font-weight: var(--weight-font-Regular);
      color: var(--font-color-2);
      margin: 4px 0 12px 0;
    }
  }
  .zk-export-notice-card__tips-dec {
    font-weight: var(--weight-font-Regular);
    color: var(--font-color-1);
    margin: 4px 0 12px 0;
  }
  .zk-export-notice-card__tips-title {
    font-size: var(--size-font-6);
    font-weight: var(--notice-card-title-weight);
    color: var(--font-color-1);
    line-height: 24px;
  }
  .zk-export-notice-card__tips-complete {
    display: flex;
    .zk-export-notice-card__tips-num {
      font-weight: var(--weight-font-Regular);
      margin: 4px 0 12px 0;
      .zk-export-notice-card__tips-info {
        width: 100%;
        word-break: break-word;
      }
    }
  }
  &:before {
    background-color: var(--main-bg-color);
  }
  // .el-button {
  //   height: 30px;
  // }
  .zk-export-notice-card__action-submit {
    margin-left: 12px;
  }
  .el-row--flex.is-align-bottom {
    justify-content: flex-end;
  }
}
</style>
